import {
  getLeaderboardDescriptionProps, getTimeframeHeaderText, getTotalParticipantHeaderText,
} from 'fitbeat.gym-core';
import { IUserLeaderboardViewModel } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import medalIcon from '../assets/icons/medal.svg';
import { TranslateProp } from '../common-types';
import {
  Button,
  ButtonSize,
  ButtonTypes,
  Icon,
} from '../components';
import { openLeaderboardModal } from '../SummaryDashboard/actions';
import Theme from '../theme';
import { SVGIcon } from '../ui/components';
import { ChevronRightIcon } from '../ui/components/Icons';
import { defaultScale } from '../utils';

interface IProps {
  leaderboardData: IUserLeaderboardViewModel;
  t: TranslateProp;
  canDrillIn: boolean;
  openLeaderboardModal: (
    leaderboard: IUserLeaderboardViewModel,
    didOpenLeaderboardModalFromDashboard: boolean,
  ) => void;
  displayedOnDashboard: boolean;
}

const JoinLeaderboardScreen: FunctionComponent<IProps> = (props: IProps) => {
  const leaderboardDescriptionProps = getLeaderboardDescriptionProps(
    props.leaderboardData,
  );

  const descriptionLine = (text: string) => (
    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: defaultScale(5) }}>
      <SVGIcon
        Icon={ChevronRightIcon}
        color={Theme.PRIMARY}
        style={{ height: defaultScale(14), width: defaultScale(10) }}
      />
      <Text style={styles.descriptionText}>{text}</Text>
    </View>
  );

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <SVGIcon
          Icon={medalIcon}
          color={Theme.PRIMARY}
          style={{ height: defaultScale(55), width: defaultScale(46) }}
        />
        <Text style={styles.header}>
          {props.leaderboardData.name}
          {' '}
        </Text>
        {props.canDrillIn
          && (
            <View style={styles.arrowContainer}>
              <Icon
                size={defaultScale(18)}
                color={Theme.GREY_DARK_MEDIUM}
                name='ios-arrow-forward'
              />
            </View>
          )}
      </View>
      <View style={styles.descriptionContainer}>
        {descriptionLine(getTotalParticipantHeaderText(props.leaderboardData))}
        {descriptionLine(props.leaderboardData.competitionType === 'individual'
          ? props.t('dashboard:individualLeaderboardDescription', {
            metric: leaderboardDescriptionProps.metric,
          })
          : props.t('dashboard:teamLeaderboardDescription', {
            denominator: leaderboardDescriptionProps.denominator,
            metric: leaderboardDescriptionProps.metric,
          }))}
        {descriptionLine(getTimeframeHeaderText(props.leaderboardData))}
      </View>
      {props.leaderboardData.requireOptIn
        && (
        <View style={{ marginTop: defaultScale(20) }}>
          <Button
            title={props.t('dashboard:joinChallenge')}
            buttonType={ButtonTypes.OUTLINE}
            size={ButtonSize.MEDIUM}
            onPress={() => props.openLeaderboardModal(props.leaderboardData, props.displayedOnDashboard)}
          />
        </View>
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: defaultScale(18),
    backgroundColor: Theme.WHITE,
  },
  arrowContainer: {
    alignSelf: 'center',
  },
  header: {
    ...Theme.textStyle.heading,
    flex: 1,
    alignSelf: 'center',
    marginLeft: defaultScale(14),
    marginRight: defaultScale(10),
  },
  subHeaderContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: defaultScale(10),
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  descriptionContainer: {
    marginTop: defaultScale(20),
    flex: 1,
    paddingRight: defaultScale(20),
  },
  descriptionText: {
    marginLeft: defaultScale(8),
    ...Theme.textStyle.bodyCopyReg,
  },
});

const mapDispatchToProps = (dispatch) => ({
  openLeaderboardModal: (
    leaderboard: IUserLeaderboardViewModel,
    didOpenLeaderboardModalFromDashboard: boolean,
  ) => dispatch(openLeaderboardModal(leaderboard, didOpenLeaderboardModalFromDashboard, true)),
});

export const JoinLeaderboard = connect(null, mapDispatchToProps)(JoinLeaderboardScreen);
